import { Sparkles, Award, Flower2, CalendarCheck, MapPin, HeartHandshake } from "lucide-react";
import { SectionTitle } from "./SectionTitle";
import { WHY_ITEMS } from "../../content/pages";

const ICONS = { Sparkles, Award, Flower2, CalendarCheck, MapPin, HeartHandshake };

export const WhySection = () => (
  <section className="bg-cream-grad py-20 lg:py-28" data-testid="why-section">
    <div className="container-lux">
      <SectionTitle eyebrow="Neden Lunessa" title="Sivas’ta Masaj İçin Neden Lunessa?" sub="Kendinizi güvende ve rahat hissetmeniz için her detayı özenle düşünüyoruz." />
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3 lg:gap-6">
        {WHY_ITEMS.map((w, i) => {
          const Icon = ICONS[w.icon];
          return (
            <div key={w.title} className="card-lux p-7" data-testid={`why-item-${i}`}>
              <span className="mb-5 flex h-12 w-12 items-center justify-center rounded-full border border-gold/40 bg-gold-soft/60 text-emerald-900">
                <Icon className="h-5 w-5" strokeWidth={1.6} />
              </span>
              <h3 className="mb-2 text-lg font-semibold text-emerald-950">{w.title}</h3>
              <p className="text-sm leading-relaxed text-ink/65">{w.text}</p>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);
